import { VariableReference } from "../../variables/Variables";

export const BLUR_TYPES = ["gaussian", "background"] as const;

export type BlurType = typeof BLUR_TYPES[number];

export default interface Blur {
    type: BlurType;
    radius: number;
    variableReferences?: VariableReference[];
}
